// extracted by mini-css-extract-plugin
export var buttonContainer = "donateButton-module--buttonContainer--BzLlu";
export var donateButton = "donateButton-module--donateButton--lav0i";
export var golfButton = "donateButton-module--golfButton--3pCY+";
export var shopButton = "donateButton-module--shopButton--p9qSC";
export var teamButton = "donateButton-module--teamButton--IfGTb";